/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Refresh_TitleInputs */

const en_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const fr_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser`)
};

const de_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const ru_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить`)
};

const es_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refrescar`)
};

const zh_cn2_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新`)
};

const ja_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リフレッシュ`)
};

const hi_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ताज़ा करना`)
};

const pt_pt2_event_templates_refresh_title = /** @type {(inputs: Event_Templates_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Event_Templates_Refresh_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_refresh_title = /** @type {((inputs?: Event_Templates_Refresh_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Refresh_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_templates_refresh_title(inputs)
	if (locale === "de") return de_event_templates_refresh_title(inputs)
	if (locale === "it") return it_event_templates_refresh_title(inputs)
	if (locale === "ru") return ru_event_templates_refresh_title(inputs)
	if (locale === "es") return es_event_templates_refresh_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_templates_refresh_title(inputs)
	if (locale === "ja") return ja_event_templates_refresh_title(inputs)
	if (locale === "hi") return hi_event_templates_refresh_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_templates_refresh_title(inputs)
	return en_event_templates_refresh_title(inputs)
});